import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

import PortalLayout from '../layouts/PortalLayout.vue'
import ForceChangePwd from '../views/ForceChangePwd.vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Profile from '../views/Profile.vue'

const ui = (name: 'Forbidden' | 'NotFound' | 'NetworkError' | 'AppUnavailable') => () =>
  import('@yc/ui-kit').then((m) => m[name])

export const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { public: true, blank: true },
  },
  {
    path: '/force-change-pwd',
    name: 'force-change-pwd',
    component: ForceChangePwd,
    meta: { public: true, blank: true },
  },
  {
    path: '/',
    component: PortalLayout,
    children: [
      { path: '', name: 'home', component: Home, meta: { perm: 'portal:home' } },
      { path: 'profile', name: 'profile', component: Profile },
      {
        path: 'admin/tenants',
        name: 'tenant-admin',
        component: () => import('../views/TenantAdmin.vue'),
        meta: { perm: 'portal:tenant' },
      },
      {
        path: 'admin/depts',
        name: 'dept-admin',
        component: () => import('../views/DeptAdmin.vue'),
        meta: { perm: 'portal:dept' },
      },
      {
        path: 'admin/users',
        name: 'user-admin',
        component: () => import('../views/UserAdmin.vue'),
        meta: { perm: 'portal:user' },
      },
      {
        path: 'admin/roles',
        name: 'role-admin',
        component: () => import('../views/RoleAdmin.vue'),
        meta: { perm: 'portal:role' },
      },
      {
        // path 必须与 iam 清单 services/iam/internal/access/portal_permissions.yaml 里
        // portal:audit 的 route 逐字一致：菜单 route 是 iam 下发的权威值，
        // 侧边栏按 route 直接导航，前端只能迁就它（曾写成 admin/audit-logs，菜单一点就 404）。
        // 后端接口路径 /iam/api/admin/audit-logs 与此无关，不要被它带偏。
        path: 'admin/audit',
        name: 'audit-log',
        component: () => import('../views/AuditLog.vue'),
        meta: { perm: 'portal:audit' },
      },
      {
        // 同 portal:audit：path 与清单里 portal:demo 的 route（/admin/demo）逐字一致。
        // 后端接口在 /iam/api/admin/demo/*，与此处的页面路由是两回事。
        path: 'admin/demo',
        name: 'demo-data',
        component: () => import('../views/DemoData.vue'),
        meta: { perm: 'portal:demo' },
      },
      { path: '403', name: 'forbidden', component: ui('Forbidden') },
    ],
  },
  {
    // 放在鉴权布局之外：企业被停用（40303）时 /me 本身就会失败，若仍走布局，
    // 外壳会继续发注定失败的请求，且守卫每次都判定"未登录"从而在登录页与本页之间死循环。
    path: '/app-unavailable',
    name: 'app-unavailable',
    component: ui('AppUnavailable'),
    meta: { public: true, blank: true },
    props: (route) => ({
      code: Number(route.query.code ?? 40301),
      msg: String(route.query.msg ?? ''),
    }),
  },
  {
    path: '/network-error',
    name: 'network-error',
    component: ui('NetworkError'),
    meta: { public: true, blank: true },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: ui('NotFound'),
    meta: { public: true, blank: true },
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router